/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const o={bitset:{isSDF:0,isMapAligned:1,scaleSymbolsProportionally:2,overrideOutlineColor:3,colorLocked:4,isStroke:5}};export{o as MarkerConstants};
